import React, { createContext, useContext } from 'react';

interface MultiSelectContextType {
    handleMultiSelect: (index: number, event: React.MouseEvent) => void;
    handleDeleteTrack: () => void;
    handleAfterCopyOrDel: () => void;
}

const MultiSelectContext = createContext<MultiSelectContextType | null>(null);

export const MultiSelectProvider = ({
    children,
    value,
}: {
    children: React.ReactNode;
    value: MultiSelectContextType;
}) => {
    return <MultiSelectContext.Provider value={value}>{children}</MultiSelectContext.Provider>;
};

export const useMultiSelect = () => {
    const context = useContext(MultiSelectContext);
    if (!context) {
        throw new Error('useMultiSelect must be used within a MultiSelectProvider');
    }
    return context;
};
